import { ComponentPropsWithoutRef } from 'react';

export default function HorizontalResizer(
  props: ComponentPropsWithoutRef<'svg'>,
) {
  return (
    <svg width="3px" height="12px" viewBox="0 0 3 12" version="1.1" {...props}>
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        opacity="0.699999988"
      >
        <g transform="translate(-49.000000, -460.000000)" fill="#72ADF2">
          <g id="Group-22" transform="translate(49.000000, 300.000000)">
            <g id="Group-27" transform="translate(0.000000, 143.500000)">
              <path
                d="M2,16.5 L3,16.5 L3,28.5 L2,28.5 Z M0,16.5 L1,16.5 L1,28.5 L0,28.5 Z"
                id="icon-/-move"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
